export default "__VITE_ASSET__DfG6PwIn__"